module.exports = __webpack_public_path__ + "static/img/UPPayTeachingIcon.2eeaba7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/UPPayTeachingIcon.gif
// module id = Vo77
// module chunks = 0